import { Form, SubmitButton, TextAreaInputField } from '@/components';
import { useForm } from '@/hooks';
import { zodResolver } from '@hookform/resolvers/zod';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { z } from 'zod';
import { CabinetDecisionWithDefinedIndicatorsModel } from '../../../_models/project';

type FormValues = z.infer<typeof CabinetDecisionWithDefinedIndicatorsModel>;

interface Props {
  initialValues?: Partial<FormValues>;
  onSubmit: (values: FormValues) => void;
}

export const CabinetDecisionsForm: FC<Props> = ({
  initialValues,
  onSubmit,
}) => {
  const { t } = useTranslation();
  const {
    handleSubmit,
    control,
    formState: { errors, isSubmitting, isDirty, isSubmitSuccessful },
  } = useForm<FormValues>({
    defaultValues: initialValues,
    resolver: zodResolver(CabinetDecisionWithDefinedIndicatorsModel),
  });

  return (
    <Form
      leavePageAlertCondition={{
        isDirty,
        isSubmitting,
        isSubmitSuccessful,
      }}
      layout="vertical"
      onFinish={handleSubmit(onSubmit)}
    >
      <TextAreaInputField
        name="name"
        label={t('analisis-kesesuaian-penggunaan-anggaran')}
        control={control}
        errors={errors}
        rows={3}
      />

      <TextAreaInputField
        name="relevantPart"
        label={t('analisis-capaian-tujuan-program')}
        control={control}
        errors={errors}
        rows={3}
      />

      <SubmitButton loading={isSubmitting} disabled={!isDirty} />
    </Form>
  );
};
